<template>
  <v-dialog v-model="model" persistent max-width="1000px">
    <v-card>
      <v-card-title class="grey lighten-4 text-subtitle-1 font-weight-bold d-flex justify-space-between">
        {{ model_title }}
        <v-icon @click="onClose">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container style="max-height:600px;overflow-y: auto;">
          <a-alert v-if="alert_text" class="mt-2" type="warning" show-icon>
            <template #message>
              <div v-html="alert_text"></div>
            </template>
          </a-alert>
          <v-row class="mb-2 mt-2">
            <v-col cols="4" v-if="Category">
              <v-select v-model="type" :items="types" item-text="label" item-value="value" label="选择平台" no-data-text="无"
                outlined hide-details dense :menu-props="{ bottom: true, offsetY: true }"
                prepend-icon="mdi-ev-station" />
            </v-col>
            <v-col :cols="Category ? 8 : 12" class="d-flex">
              <v-file-input v-model="file" label="文件" accept=".xls,.xlsx,.csv" prepend-icon="mdi-microsoft-excel"
                show-size outlined hide-details dense>
                <template v-slot:selection="{ text }">
                  <v-chip label small color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
              <v-btn class="ml-2" color="primary" text tile :disabled="!file" @click="doupload"> 上传
              </v-btn>
            </v-col>
          </v-row>
          <a-table size="small" :columns="headers" bordered :data-source="list" :pagination="false"
            :locale="{ emptyText: '暂无数据' }">
            <template slot="index" slot-scope="text, record, index">
              {{ index + 1 }}
            </template>
            <template slot="originalname" slot-scope="text, record">
              <a href="javascript:;" @click="downloadfile(record)">{{ record.originalname }}</a>
            </template>
            <template slot="originalurl" slot-scope="text, record">
              <a href="javascript:;" @click="ydownloadfile(record)">
                {{ record.originalurl ? record.originalfilename : '' }}
              </a>
            </template>
            <template slot="create_time" slot-scope="text, record">
              {{ record.create_time | dateTime("YYYY-MM-DD HH:mm") }}
            </template>
            <template slot="state" slot-scope="text, record">
              <span v-if="record.state === 0" class="primary--text">
                正在处理
              </span>
              <span v-else-if="record.state === -1" class="error--text underline click">
                处理失败：{{ record.reason }}
              </span>
              <span v-else-if="record.success === 0" class="error--text underline click">
                处理失败
              </span>
              <span v-else-if="record.state === 1" class="success--text">
                处理成功
              </span>
            </template>
            <template slot="count" slot-scope="text, record">
              <div>
                <span class="primary--text">{{ record.count }}</span>/
                <span class="success--text underline click" title="成功" @click="showsuccess(record._id)">
                  {{ record.success }}
                </span>/
                <span class="error--text underline click" title="失败" @click="showfail(record._id)">
                  {{ record.fail }}
                </span>/
                <span class="orange--text underline click" title="重复" @click="showduplicate(record._id)">
                  {{ record.duplicate }}
                </span>
              </div>
            </template>
          </a-table>
          <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
        </v-container>
      </v-card-text>
      <v-card-actions>
        <a v-if="template_file" href="javascript:;" @click="downloadtemplate"> {{ template_file.name }} </a>
        <v-spacer></v-spacer>
        <v-btn color="primary" tile text @click="getdata()">刷新</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "uploadtask",
  props: ["modelTitle", "alertText", "uploadType", "templateFile", "Category"],
  data() {
    return {
      model_title: "",
      alert_text: "",
      model: false,
      upload_type: "",
      template_file: null,
      category: false,
      page: 1,
      limit: 10,
      list: [],
      length: 0,
      count: 0,
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "文件", dataIndex: "originalname", scopedSlots: { customRender: "originalname" }, width: 120, align: "center" },
        ...(this.Category ? [
          { title: "原文件", dataIndex: "originalurl", scopedSlots: { customRender: "originalurl" }, width: 120, align: "center" },
        ] : []),
        { title: "上传时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 160, align: "center" },
        { title: "上传人", dataIndex: "create_by", scopedSlots: { customRender: "create_by" }, width: 100, align: "center" },
        { title: "状态", dataIndex: "state", scopedSlots: { customRender: "state" }, width: 100, align: "center" },
        { title: "总数/成功/失败/重复", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 150, align: "center" },
      ],
      file: null,
      type: '',
      types: [
        { label: '星星充电', value: '星星充电' },
        { label: '五牛新能源', value: '五牛新能源' },
        { label: '特来电', value: '特来电' },
        { label: '云快充', value: '云快充' },
        { label: '新电途', value: '新电途' },
      ],
      // 基础模板：统一输出的16列格式
      // sourceKey 由各充电类型手动映射，未映射的列值为空
      typeTemplates: [
        { targetKey: '订单号', sourceKey: '' },
        { targetKey: '车牌号', sourceKey: '' },
        { targetKey: '开始时间', sourceKey: '' },
        { targetKey: '结束时间', sourceKey: '' },
        { targetKey: '充电时长(分钟)', sourceKey: '' },
        { targetKey: '充电量(度)', sourceKey: '' },
        { targetKey: '尖时(度)', sourceKey: '' },
        { targetKey: '峰时(度)', sourceKey: '' },
        { targetKey: '平时(度)', sourceKey: '' },
        { targetKey: '谷时(度)', sourceKey: '' },
        { targetKey: '深谷(度)', sourceKey: '' },
        { targetKey: '充电费(元)', sourceKey: '' },
        { targetKey: '服务费(元)', sourceKey: '' },
        { targetKey: '总额(元)', sourceKey: '' },
        { targetKey: '充电桩地点', sourceKey: '' },
        { targetKey: '平台名称', sourceKey: '' },
      ],
    };
  },
  computed: {
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  watch: {
    modelTitle(value) {
      this.model_title = value;
    },
    alertText(value) {
      this.alert_text = value;
    },
    uploadType(value) {
      this.upload_type = value;
    },
    templateFile(value) {
      this.template_file = value;
    },
    Category(value) {
      this.category = value;
    },
    page() {
      this.getdata();
    },
  },
  activated() {
    this.model_title = this.modelTitle;
    this.alert_text = this.alertText;
    this.upload_type = this.uploadType;
    this.template_file = this.templateFile;
    this.category = this.Category;
  },
  methods: {
    reset() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/uploadtask/list", { page: this.page, limit: this.limit, type: this.upload_type }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    checkfile(file) {
      if (!file) {
        this.$alert("文件不能为空");
        return { code: 1 };
      }
      const isLt10M = file.size / 1024 / 1024 < 2
      if (!isLt10M) {
        this.$alert("文件不能超过2MB");
        return { code: 1 };
      }
      return { code: 0 };
    },
    async doupload() {
      let checkresult = this.checkfile(this.file);
      if (checkresult.code !== 0) return;
      // Category 模式下必须选择充电类型
      if (this.Category && !this.type) {
        this.$alert('请选择充电类型');
        return;
      }
      // Category 模式：读取文件 → 按模板转换列名 → 生成统一格式 Excel
      let uploadFile = this.file;
      if (this.Category) {
        try {
          this.$toast.loading({ message: "正在处理文件..." });
          let rawData = await this.readExcel(this.file);
          console.log(rawData);
          // 按模板转换列名，得到统一格式的 { headers, rows }
          let transformedData = this.transformData(rawData);
          console.log(transformedData);
          // 从统一格式生成新 Excel 文件
          uploadFile = await this.generateExcel(transformedData);
          console.log(uploadFile);
          this.$toast.clear();
        } catch (e) {
          this.$toast.clear();
          console.error(e);
          this.$alert(e.message || '文件处理失败');
          return;
        }
      }
      this.$toast.loading({ message: "" });
      let file = uploadFile;
      const slicefiles = this.$utils.sliceFile(file.size);
      const faid = this.$utils.uuid();
      for (let j = 0; j < slicefiles.length; j++) {
        let slicefile = slicefiles[j];
        const formData = new FormData();
        if (slicefile.chunks > 1) {
          let _file = file.slice(slicefile.from, slicefile.to);
          formData.set("file", _file);
        } else {
          formData.set("file", file);
        }
        formData.set("faid", faid);
        formData.set("chunk", slicefile.chunk);
        formData.set("chunks", slicefile.chunks);
        formData.set("originalname", file.name);
        formData.set("type", this.upload_type);
        try {
          let res = await this.$api.doUpload("/uploadtask/plupload", formData);
          if (res.code === 0) {
            if (slicefile.chunk + 1 === slicefile.chunks) {
              this.$toast.clear();
              if (this.Category) {
                this.thesecondtime(res.data.fileid);
                return
              }
              this.getdata();
            }
          } else {
            this.$toast.clear();
            this.$alert(res.msg);
            break;
          }
        } catch (e) {
          console.error(e);
          this.$toast.clear();
          this.$alert(e.message);
          break;
        }
      }
      this.file = null;
    },
    async thesecondtime(fileid) {
      let checkresult = this.checkfile(this.file);
      if (checkresult.code !== 0) return;
      let uploadFile = this.file;
      this.$toast.loading({ message: "" });
      let file = uploadFile;
      const slicefiles = this.$utils.sliceFile(file.size);
      const faid = this.$utils.uuid();
      for (let j = 0; j < slicefiles.length; j++) {
        let slicefile = slicefiles[j];
        const formData = new FormData();
        if (slicefile.chunks > 1) {
          let _file = file.slice(slicefile.from, slicefile.to);
          formData.set("file", _file);
        } else {
          formData.set("file", file);
        }
        formData.set("faid", faid);
        formData.set("chunk", slicefile.chunk);
        formData.set("chunks", slicefile.chunks);
        formData.set("originalname", file.name);
        formData.set("type", this.upload_type + "_original");
        if (fileid) {
          formData.set("fileid", fileid);
        }
        try {
          let res = await this.$api.doUpload("/uploadtask/plupload", formData);
          if (res.code === 0) {
            if (slicefile.chunk + 1 === slicefile.chunks) {
              this.$toast.clear();
              this.getdata();
            }
          } else {
            this.$toast.clear();
            this.$alert(res.msg);
            break;
          }
        } catch (e) {
          console.error(e);
          this.$toast.clear();
          this.$alert(e.message);
          break;
        }
      }
      this.file = null;
    },
    showsuccess(_id) {
      this.showresult(_id, 'success');
    },
    showfail(_id) {
      this.showresult(_id, 'fail');
    },
    showduplicate(_id) {
      this.showresult(_id, 'duplicate');
    },
    showresult(_id, type) {
    },
    downloadfile(item) {
      this.$download(item.remoteurl, item.originalname);
    },
    ydownloadfile(item) {
      this.$download(item.originalurl, item.originalfilename);
    },
    downloadtemplate() {
      this.$download(this.template_file.url, this.template_file.name);
    },
    showupload() {
      this.model = true;
      this.reset();
    },
    onClose() {
      this.model = false
    },
    // 计算两个时间字符串之间的分钟差，格式: "2026-07-08 17:11:51"
    calcMinutes(startTime, endTime) {
      if (!startTime || !endTime) return '';
      const start = new Date(startTime.replace(/-/g, '/'));
      const end = new Date(endTime.replace(/-/g, '/'));
      if (isNaN(start.getTime()) || isNaN(end.getTime())) return '';
      const diffMs = end.getTime() - start.getTime();
      return Math.round(diffMs / 60000);
    },
    // 读取 Excel/CSV 文件内容，返回 { headers: [...], rows: [{列名: 值}, ...] }
    readExcel(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            const XLSX = require('xlsx');
            const isCsv = file.name.toLowerCase().endsWith('.csv');
            let workbook;
            if (isCsv) {
              // CSV：处理编码后解析
              let csvText = e.target.result;
              // 移除 BOM 头
              if (csvText.charCodeAt(0) === 0xFEFF || csvText.charCodeAt(0) === 0xFFFE) {
                csvText = csvText.slice(1);
              }
              try {
                // CSV 也启用 cellDates/dateNF，让日期类型尽量保持原始
                workbook = XLSX.read(csvText, { type: 'string', cellDates: true, dateNF: 'yyyy-mm-dd hh:mm:ss' });
              } catch (csvErr) {
                // 扩展名为 .csv 但实际是 xlsx 等 ZIP 格式，回退为二进制解析
                const buf = await file.arrayBuffer();
                workbook = XLSX.read(new Uint8Array(buf), { type: 'array', cellDates: true, dateNF: 'yyyy-mm-dd hh:mm:ss' });
              }
            } else {
              // Excel 文件直接解析
              // cellDates: true  让日期格返回 Date 对象（原始值），不被转成 Excel 序列号
              // dateNF          指定 Date 序列化格式
              // cellNF: true    保留单元格原始数字格式
              workbook = XLSX.read(e.target.result, { type: 'array', cellDates: true, cellNF: true, dateNF: 'yyyy-mm-dd hh:mm:ss' });
            }
            // 取第一个工作表
            const firstSheetName = workbook.SheetNames[0];
            if (!firstSheetName) {
              reject(new Error('文件中没有工作表'));
              return;
            }
            const worksheet = workbook.Sheets[firstSheetName];
            // 转为 JSON 数组，第一行作为表头
            // raw: true 返回单元格原始值（数字保持 number、Date 保持 Date），不被 xlsx 强制转字符串
            // dateNF 让 Date 序列化为 yyyy-mm-dd hh:mm:ss
            const data = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: true, dateNF: 'yyyy-mm-dd hh:mm:ss', defval: '' });
            if (!data || data.length < 1) {
              reject(new Error('文件内容为空'));
              return;
            }
            // 把每一行 / 每一个单元格里的 Date 转成 yyyy-mm-dd hh:mm:ss 字符串，
            // 这样下游 transformData 拿到的就是「原始值」格式，不会再被 xlsx 转成 Excel 序列号。
            const formatCell = (v) => {
              if (v == null) return '';
              if (v instanceof Date) {
                if (isNaN(v.getTime())) return '';
                const pad = (n) => (n < 10 ? '0' + n : '' + n);
                return v.getFullYear() + '-' + pad(v.getMonth() + 1) + '-' + pad(v.getDate())
                  + ' ' + pad(v.getHours()) + ':' + pad(v.getMinutes()) + ':' + pad(v.getSeconds());
              }
              return v;
            };
            for (let i = 0; i < data.length; i++) {
              if (Array.isArray(data[i])) {
                for (let j = 0; j < data[i].length; j++) {
                  data[i][j] = formatCell(data[i][j]);
                }
              }
            }
            let start = 0;
            if (this.type == '特来电') {
              for (let i = 0; i < data.length; i++) {
                let item = data[i];

                if (item.includes('序号') && item.includes('订单编号') && item.includes('电站名称')) {
                  start = i;
                  break;
                }
              }
            }
            if (this.type == '云快充') {
              console.log(data);
              for (let i = 0; i < data.length; i++) {
                let item = data[i];
                if (item.includes('订单号') && item.includes('订单类型') && item.includes("销售订单金额（元）") && item.includes("销售服务费金额（元）")) {
                  start = i;
                  break;
                }
              }
            }
            const headers = data[start].map(h => h != null ? String(h).trim() : '');
            const rows = data.slice(start + 1).map((row) => {
              const obj = {};
              headers.forEach((key, i) => {
                obj[key] = row[i] != null ? row[i] : '';
              });
              return obj;
            }).filter(row => {
              // 过滤空行
              return Object.values(row).some(v => v !== '' && v != null);
            });
            resolve({ headers, rows });
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = () => reject(new Error('文件读取失败'));
        const isCsv = file.name.endsWith('.csv');
        if (isCsv) {
          reader.readAsText(file, 'UTF-8');
        } else {
          reader.readAsArrayBuffer(file);
        }
      });
    },
    // 按模板手动映射列名，输出统一格式 { headers, rows }
    // sourceKey 有值时从原始数据取值，sourceKey 为空时输出空字符串
    transformData(rawData) {
      const template = this.typeTemplates;
      const headers = template.map(col => col.targetKey);
      const rows = rawData.rows.filter((srcRow) => {
        // 过滤充电量为0的行
        if (this.type == "星星充电") return Number(srcRow['订单电量']) !== 0;
        if (this.type == "五牛新能源") return Number(srcRow['充电量（度）']) !== 0;
        if (this.type == "新电途") return Number(srcRow['充电量']) !== 0;
        if (this.type == "特来电") return Number(srcRow['充电量（度）']) !== 0;
        if (this.type == "云快充") return Number(srcRow['充电电量（度）']) !== 0;
        // TODO: 其他类型按需补充过滤条件
        return true;
      }).map((srcRow) => {
        const newRow = {};
        if (this.type == "星星充电") {
          newRow["订单号"] = srcRow['业务订单编号'];
          newRow["车牌号"] = srcRow['订单车牌号'];
          newRow["开始时间"] = srcRow['开始时间'];
          newRow["结束时间"] = srcRow['停止时间'];
          newRow["充电时长(分钟)"] = this.calcMinutes(srcRow['开始时间'], srcRow['停止时间']);
          newRow["充电量(度)"] = srcRow['订单电量'];
          newRow["尖时(度)"] = srcRow['尖电量'];
          newRow["峰时(度)"] = srcRow['峰电量'];
          newRow["平时(度)"] = srcRow['平电量'];
          newRow["谷时(度)"] = srcRow['谷电量'];
          newRow["深谷(度)"] = srcRow['深谷电量'];
          newRow["服务费(元)"] = srcRow['订单服务费'];
          newRow["总额(元)"] = srcRow['订单总金额'];
          newRow["充电费(元)"] = srcRow['订单电费'];
          newRow["充电桩地点"] = srcRow['电站名称'];
          newRow["平台名称"] = '星星充电'//srcRow['平台名称'] ;
        }
        if (this.type == "五牛新能源") {
          newRow["订单号"] = srcRow['订单ID'];
          newRow["车牌号"] = srcRow['车牌号'];
          newRow["开始时间"] = srcRow['开始充电时间'];
          newRow["结束时间"] = srcRow['充电完成时间'];
          newRow["充电时长(分钟)"] = srcRow['充电时长（分钟）'];
          newRow["充电量(度)"] = srcRow['充电量（度）'];
          newRow["尖时(度)"] = srcRow['尖时电量'];
          newRow["峰时(度)"] = srcRow['峰时电量'];
          newRow["平时(度)"] = srcRow['平时电量'];
          newRow["谷时(度)"] = srcRow['谷时电量'];
          newRow["深谷(度)"] = srcRow['深谷电量'];
          newRow["服务费(元)"] = srcRow['充电服务费（元）'];
          newRow["总额(元)"] = srcRow['订单总额（元）'];
          newRow["充电费(元)"] = srcRow['充电电费（元）'];
          newRow["充电桩地点"] = srcRow['场站名称'];
          newRow["平台名称"] = '五牛新能源'//srcRow['平台名称'] ;
        }
        if (this.type == "新电途") {
          newRow["订单号"] = srcRow['充电订单号'];
          newRow["车牌号"] = srcRow['车牌号'];
          newRow["开始时间"] = srcRow['开始充电时间'];
          newRow["结束时间"] = srcRow['停止充电时间'];
          newRow["充电时长(分钟)"] = srcRow['充电时长(分钟)'];
          newRow["充电量(度)"] = srcRow['充电量'];
          newRow["尖时(度)"] = srcRow['尖电量(kWh)'];
          newRow["峰时(度)"] = srcRow['峰电量(kWh)'];
          newRow["平时(度)"] = srcRow['平电量(kWh)'];
          newRow["谷时(度)"] = srcRow['谷电量(kWh)'];
          newRow["深谷(度)"] = srcRow['深电量(kWh)'];
          newRow["服务费(元)"] = srcRow['服务费'];
          newRow["总额(元)"] = srcRow['订单金额'];
          newRow["充电桩地点"] = srcRow['场站名称'];
          newRow["充电费(元)"] = srcRow['充电费'];
          newRow["平台名称"] = '新电途'//srcRow['平台名称'] ;
        }
        if (this.type == "特来电") {
          newRow["订单号"] = srcRow['订单编号'];
          newRow["车牌号"] = srcRow['车牌号'];
          newRow["开始时间"] = srcRow['订单开始时间'];
          newRow["结束时间"] = srcRow['订单结束时间'];
          newRow["充电时长(分钟)"] = this.calcMinutes(srcRow['订单开始时间'], srcRow['订单结束时间']);
          newRow["充电量(度)"] = srcRow['充电量（度）'];
          newRow["尖时(度)"] = srcRow['尖时电量（度）'];
          newRow["峰时(度)"] = srcRow['峰时电量（度）'];
          newRow["平时(度)"] = srcRow['平时电量（度）'];
          newRow["谷时(度)"] = srcRow['谷时电量（度）'];
          newRow["深谷(度)"] = srcRow['深谷时电量（度）'];
          newRow["服务费(元)"] = srcRow['服务费（元）'];
          newRow["总额(元)"] = srcRow['订单金额（元）'];
          newRow["充电费(元)"] = srcRow['电费（元）'];
          newRow["充电桩地点"] = srcRow['电站名称'];
          newRow["平台名称"] = '特来电'//srcRow['平台名称'] ;
        }
        if (this.type == "云快充") {
          newRow["订单号"] = srcRow['订单号'];
          newRow["车牌号"] = srcRow['车牌号码'];
          newRow["开始时间"] = srcRow['开始时间'];
          newRow["结束时间"] = srcRow['结束时间'];
          newRow["充电时长(分钟)"] = this.calcMinutes(srcRow['开始时间'], srcRow['结束时间']);
          newRow["充电量(度)"] = srcRow['充电电量（度）'];
          newRow["尖时(度)"] = srcRow['尖电度数'];
          newRow["峰时(度)"] = srcRow['峰电度数'];
          newRow["平时(度)"] = srcRow['平电度数'];
          newRow["谷时(度)"] = srcRow['谷电度数'];
          newRow["深谷(度)"] = srcRow['深谷电度数'];
          newRow["服务费(元)"] = srcRow['销售服务费金额（元）'];
          newRow["总额(元)"] = srcRow['销售订单金额（元）'];
          newRow["充电费(元)"] = srcRow['销售电费金额（元）'];
          newRow["充电桩地点"] = srcRow['充电场站'];
          newRow["平台名称"] = '云快充'//srcRow['平台名称'] ;
        }
        return newRow;
      });
      return { headers, rows };
    },
    // 从统一格式的 { headers, rows } 生成 Excel 文件
    async generateExcel(data) {
      const ExcelJS = require('exceljs');
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');
      // 写入表头
      worksheet.addRow(data.headers);
      // 写入数据行
      data.rows.forEach((row) => {
        const values = data.headers.map(key => row[key] != null ? row[key] : '');
        worksheet.addRow(values);
      });
      // 导出为 File 对象
      const buffer = await workbook.xlsx.writeBuffer();
      // 生成的内容为 xlsx 格式，需将文件名后缀统一替换为 .xlsx，
      // 否则后端按后缀校验时会拒绝（如原始为 .csv 会报"只允许上传xls/xlsx格式文件"）
      // 同时在文件名中拼上当前平台（this.type），方便下载后区分来源
      const baseName = this.file.name.replace(/\.[^.]+$/, '');
      const platformTag = this.type ? `_${this.type}` : '';
      const newFileName = `${baseName}${platformTag}.xlsx`;
      const newFile = new File(
        [buffer],
        newFileName,
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      return newFile;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}
</style>
